import { BaseFetch } from "../main-model"
export default class ReportPublicUtilitiesModel extends BaseFetch {
    getReportPublicUtilitiesBy = (data) =>
    this.authFetch({
      url: "report-public-utilities/getReportPublicUtilitiesBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportPublicUtilitiesTotalBy = (data) =>
    this.authFetch({
      url: "report-public-utilities/getReportPublicUtilitiesTotalBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportPublicUtilitiesAllSchoolBy = (data) =>
    this.authFetch({
      url: "report-public-utilities/getReportPublicUtilitiesAllSchoolBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
